import { type OpenApiSchemaProductVariant } from '#shared/api/schema';

export class ProductVariantBeforePublishingError extends Error {}

export const checkingProductVariantBeforePublishing = (variant: Pick<OpenApiSchemaProductVariant, 'price'>) => {
    if (Number(variant.price) === 0) {
        throw new ProductVariantBeforePublishingError('Нельзя опубликовать товар без Цены до скидки');
    }
};
